import { memo } from "react";
import { displayChordSymbol } from "@/music/chords/chordTheoryEngine";
import { getChordLabel } from "@/music/chords/chordSyncUtils";

const formatTime = (seconds = 0) => {
  const safe = Math.max(0, Number(seconds) || 0);
  return `${Math.floor(safe / 60)}:${String(Math.floor(safe % 60)).padStart(2, "0")}`;
};

const ChordTimelineStrip = memo(({ chords = [], activeIndex = -1, onSeek, compact = false, disabled = false, variant = "dark" }) => (
  <div className="steel-scroll-soft flex gap-1.5 overflow-x-auto pb-1" aria-label="Timeline de acordes">
    {chords.length === 0 ? (
      <p className={`text-sm ${variant === "light" ? "text-slate-500" : "text-gray-500"}`}>Sin acordes sincronizados.</p>
    ) : (
      chords.map((chord, index) => (
        <button
          type="button"
          key={`${chord.start}-${getChordLabel(chord)}-${index}`}
          onClick={() => onSeek?.(chord.start)}
          disabled={disabled}
          aria-current={activeIndex === index ? "true" : undefined}
          className={`shrink-0 rounded-md border px-3 transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
            compact ? "min-h-10 py-1" : "min-h-12 py-1.5"
          } ${
            variant === "light"
              ? activeIndex === index
                ? "border-teal-600 bg-teal-50 text-slate-900 shadow-[inset_0_-3px_0_#0d9488]"
                : "border-slate-200 bg-white text-slate-700 hover:border-teal-300"
              : activeIndex === index
                ? "border-cyan-300/50 bg-cyan-300/15 text-cyan-100"
                : "border-white/10 bg-black/20 text-gray-300 hover:border-cyan-300/30"
          }`}
        >
          <span className="block text-sm font-semibold">{displayChordSymbol(getChordLabel(chord))}</span>
          <span className={`block text-[11px] ${variant === "light" ? "text-slate-400" : "text-gray-400"}`}>{formatTime(chord.start)}</span>
        </button>
      ))
    )}
  </div>
));

ChordTimelineStrip.displayName = "ChordTimelineStrip";

export default ChordTimelineStrip;
